import { isAnyAdmin } from 'permissions/v1/roles';
import { canView, canCreate, canUpdate, canDestroy, noPermissions } from 'permissions/v1/index';
import { hasTrainings } from 'permissions/v1/preferences';

const permission = 'Training';

const list = () => true;
const view = (profile) => isAnyAdmin(profile) || canView(permission, profile);
const create = (profile) => isAnyAdmin(profile) || canCreate(permission, profile);
const update = (profile) => isAnyAdmin(profile) || canUpdate(permission, profile);
const destroy = (profile) => isAnyAdmin(profile) || canDestroy(permission, profile);

const permissions = (profile) => {
  if (!hasTrainings(profile)) return noPermissions;

  return {
    list: list(profile),
    view: view(profile),
    create: create(profile),
    update: update(profile),
    destroy: destroy(profile),
  };
};

export default permissions;
